import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-commitment-letter',
  templateUrl: './commitment-letter.component.html',
  styleUrls: ['./commitment-letter.component.css']
})
export class CommitmentLetterComponent implements OnInit {


  branchList;
  articleNameList;
  selectedBranch = [];
  role;
  isBranchSelected;
  selectArticle;
  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.loadBranchList();
    this.selectArticle="";

  }


  loadBranchList(){
    this.masterDataService.getBranch().subscribe((res) => {
      this.branchList = res;
    });
    console.log('branchList', this.branchList);
  }


  onBranchSelected() {
    this.role = 'Article';
    this.loadArticleList();
  }


  loadArticleList() {
    var branchId = this.selectedBranch.map(({ id }) => id);
    console.log('branchID', branchId);
    this.masterDataService.getArticleListByBranch(branchId).subscribe({
      next: (resp: any) => {
        console.log('article list by branch', resp);
       
        this.articleNameList = resp;
      
      },
      error: (err) => {
        console.error('Error loading article list', err);
        // Handle error as necessary, e.g., display an error message to the user
      },
      complete: () => {
        console.log('Article list loading complete');
      }
    });


  }

  selectAllBranch(select: NgModel, values) {
      this.selectAll(select, values, this.isBranchSelected);
      this.isBranchSelected = !this.isBranchSelected;
      this.onBranchSelected();
    }
  
    selectAllArticleName(select: NgModel, values) {
      this.selectAll(select, values, this.isBranchSelected);
      this.isBranchSelected = !this.isBranchSelected;
    }
  
    selectAll(select: NgModel, values, isSelected) {
      if (!isSelected) {
        select.update.emit(values);
      } else select.update.emit([]);
    }


    ExportLetter() {

     
    if(this.selectArticle == undefined || this.selectArticle == null ||  this.selectArticle == "" || this.selectedBranch==null){
      this.commonMessageService.swalAlertWithoutIcon('',"Please select all filters.");
      return;
    }

    const fullName = [
      this.selectArticle.firstName,
      this.selectArticle.middleName,
      this.selectArticle.lastName
    ]
      .filter(Boolean)
      .join('_');
      // Call the exportCommitmentLetter API with the selected article ID
      this.masterDataService.exportCommitmentLetter(this.selectArticle.id).subscribe({
        next: (res: Blob) => {
          const blob = new Blob([res], { type: 'application/pdf' });

          const downloadURL = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'CommitmentLetter_' + fullName + '.pdf';

          link.click();

          window.URL.revokeObjectURL(downloadURL);

          console.log('PDF downloaded successfully');
        },
        error: (err) => {
          console.error('Error generating letter', err);
          // Handle error as necessary, e.g., display an error message to the user
        },
        complete: () => {
          // Show success alert upon successful export
          this.commonMessageService.swalAlertWithIcon('', 'Generated Successfully!', 'success');
        }
      });
    }


    
}
